var _defs, _path, _rect, _path2, _path3, _rect2, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacilityManagement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 650 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:#f5f3f5;}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#linear-gradient-4);}.cls-6{fill:url(#linear-gradient-5);}.cls-7{fill:url(#linear-gradient-6);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 257.14,
    y1: 221.17,
    x2: 257.14,
    y2: 138.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5f3f5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f5f3f5",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#f5f3f5",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#f5f3f5",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#f5f3f5",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f5f3f5",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#f5f3f5",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#f5f3f5",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#f5f3f5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 196.59,
    y1: 357.28,
    x2: 196.59,
    y2: 286.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#f5f3f5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#f5f3f5",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#f5f3f5",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#f5f3f5",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#f5f3f5",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#f5f3f5",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#f5f3f5",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#f5f3f5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 298.38,
    y1: 244.27,
    x2: 308.55,
    y2: 262.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#f5f3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5f3f5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 317.69,
    y1: 357.28,
    x2: 317.69,
    y2: 304.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5f3f5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f5f3f5",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#f5f3f5",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#f5f3f5",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#f5f3f5",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#f5f3f5",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#f5f3f5",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#f5f3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#f5f3f5",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#f5f3f5",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#f5f3f5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 379.13,
    y1: 190.1,
    x2: 379.13,
    y2: 355.35,
    gradientTransform: "translate(80.35 -94.2) rotate(15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#f5f3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#f5f3f5",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#f5f3f5",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#f5f3f5",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#f5f3f5",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#f5f3f5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 379.13,
    y1: 240.54,
    x2: 379.13,
    y2: 304.9,
    xlinkHref: "#linear-gradient-5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M257.14,221.17a41.44,41.44,0,1,1,41.44-41.44A41.49,41.49,0,0,1,257.14,221.17Zm0-74a32.57,32.57,0,1,0,32.57,32.57A32.61,32.61,0,0,0,257.14,147.16Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 192.15,
    y: 286.35,
    width: 8.87,
    height: 70.92
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M201,286.35h-8.87a53.7,53.7,0,0,1,53.64-53.63h22.7a53.2,53.2,0,0,1,31.84,10.47l-5.27,7.13a44.42,44.42,0,0,0-26.57-8.74h-22.7A44.82,44.82,0,0,0,201,286.35Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M305.85,264c-3.13-5.78-5.58-9.85-10.79-13.7l5.27-7.13c6.66,4.91,9.85,10.2,13.32,16.59Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 313.26,
    y: 304.64,
    width: 8.87,
    height: 52.63
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M366.08,349.22a12.55,12.55,0,0,1-1.36-.08,57.78,57.78,0,0,1-10.12-2,58.85,58.85,0,0,1-9.76-3.34,11.46,11.46,0,0,1-7-10.8c0-2.56,0-6.09,0-9.62s0-7,0-9.53a9.1,9.1,0,0,0-1.09-4.23l-.09-.13A13.72,13.72,0,0,0,335.4,308l0,0a14.88,14.88,0,0,0-1.54-1.26l-.14-.1a9.15,9.15,0,0,0-4.22-1.08c-2.53,0-6,0-9.53,0s-7.06,0-9.62,0a11.48,11.48,0,0,1-10.8-7,74.91,74.91,0,0,1-5.33-19.87,11.49,11.49,0,0,1,5.87-11.44c2.21-1.3,5.27-3.07,8.34-4.84s6.05-3.48,8.22-4.77a9,9,0,0,0,3.13-3l.06-.14a14.07,14.07,0,0,0,.7-1.86,13.72,13.72,0,0,0,.34-2l0-.17a9.18,9.18,0,0,0-1.19-4.19c-1.24-2.2-3-5.23-4.74-8.26s-3.54-6.11-4.8-8.34a11.45,11.45,0,0,1,.65-12.84,57.32,57.32,0,0,1,6.77-7.77,59,59,0,0,1,7.77-6.78,11.47,11.47,0,0,1,12.84-.63c2.22,1.25,5.27,3,8.32,4.78s6.07,3.51,8.28,4.76a9.12,9.12,0,0,0,4.21,1.17h.15a16.57,16.57,0,0,0,2-.32,15,15,0,0,0,1.91-.72l.15-.07a9.22,9.22,0,0,0,3-3.12c1.29-2.18,3-5.21,4.78-8.24s3.53-6.12,4.83-8.32a11.45,11.45,0,0,1,11.44-5.87,75.12,75.12,0,0,1,19.88,5.33,11.44,11.44,0,0,1,7,10.8c0,2.54,0,6.05,0,9.57s0,7,0,9.57a9.14,9.14,0,0,0,1.09,4.24l.09.12a13,13,0,0,0,1.26,1.54,13.67,13.67,0,0,0,1.57,1.29l.14.11a9.29,9.29,0,0,0,4.22,1.07c2.53,0,6,0,9.53,0s7.06,0,9.62,0a11.46,11.46,0,0,1,10.8,7,57.73,57.73,0,0,1,3.34,9.74,60.27,60.27,0,0,1,2,10.13,11.49,11.49,0,0,1-5.87,11.44c-2.2,1.29-5.26,3.06-8.32,4.82s-6.06,3.49-8.24,4.78a9.21,9.21,0,0,0-3.13,3.06l-.05.13a12.91,12.91,0,0,0-.71,1.86,14,14,0,0,0-.34,2l0,.15a9.15,9.15,0,0,0,1.19,4.19c1.24,2.21,3,5.23,4.74,8.26s3.54,6.12,4.8,8.34a11.49,11.49,0,0,1-.64,12.85,59.71,59.71,0,0,1-6.78,7.77,58.86,58.86,0,0,1-7.77,6.77,11.45,11.45,0,0,1-12.84.64c-2.24-1.26-5.32-3.05-8.4-4.82s-6-3.48-8.2-4.72a9.19,9.19,0,0,0-4.21-1.18l-.14,0a13.3,13.3,0,0,0-2,.32,14.62,14.62,0,0,0-1.92.72l-.15.07a9.08,9.08,0,0,0-3,3.11c-1.29,2.18-3,5.2-4.77,8.23s-3.54,6.13-4.84,8.34A11.45,11.45,0,0,1,366.08,349.22Zm-24.42-47.54a22,22,0,0,1,2.12,2.54l.1.13a17.5,17.5,0,0,1,2.83,9.43c0,2.56,0,6.09,0,9.63s0,7,0,9.52a2.68,2.68,0,0,0,1.72,2.79,67.38,67.38,0,0,0,17.18,4.6,2.66,2.66,0,0,0,2.88-1.55c1.29-2.19,3-5.22,4.79-8.26s3.52-6.11,4.82-8.31a17.47,17.47,0,0,1,7.15-6.74l.16-.07a21.61,21.61,0,0,1,3.14-1.15,21.14,21.14,0,0,1,3.25-.56l.15,0a17.38,17.38,0,0,1,9.57,2.26c2.22,1.25,5.25,3,8.29,4.77s6.1,3.52,8.32,4.78a2.66,2.66,0,0,0,3.26-.09,50.06,50.06,0,0,0,6.72-5.88,51.16,51.16,0,0,0,5.87-6.7,2.67,2.67,0,0,0,.09-3.27c-1.24-2.21-3-5.24-4.75-8.27s-3.53-6.11-4.79-8.34a17.41,17.41,0,0,1-2.27-9.56l0-.16a21.87,21.87,0,0,1,.58-3.31,20.88,20.88,0,0,1,1.14-3.1l.06-.14a17.34,17.34,0,0,1,6.74-7.15c2.21-1.31,5.27-3.07,8.33-4.83s6.06-3.5,8.24-4.78A2.7,2.7,0,0,0,449,257a51.4,51.4,0,0,0-1.73-8.75,49.92,49.92,0,0,0-2.88-8.43,2.66,2.66,0,0,0-2.78-1.72c-2.54,0-6,0-9.53,0s-7.07,0-9.63,0a17.37,17.37,0,0,1-9.41-2.82l-.15-.11a19.06,19.06,0,0,1-4.66-4.65l-.1-.14a17.36,17.36,0,0,1-2.82-9.42c0-2.58,0-6.13,0-9.68s0-7,0-9.48a2.67,2.67,0,0,0-1.71-2.78,67.07,67.07,0,0,0-17.19-4.61,2.68,2.68,0,0,0-2.88,1.55c-1.29,2.19-3,5.22-4.78,8.25s-3.53,6.12-4.83,8.32a17.42,17.42,0,0,1-7.15,6.75l-.16.07a20.56,20.56,0,0,1-3.14,1.14,21.06,21.06,0,0,1-3.23.57H360a17.23,17.23,0,0,1-9.58-2.26c-2.24-1.26-5.3-3-8.37-4.81s-6-3.49-8.24-4.73a2.66,2.66,0,0,0-3.27.09A66.91,66.91,0,0,0,318,221.91a2.67,2.67,0,0,0-.09,3.27c1.24,2.21,3,5.24,4.75,8.26s3.53,6.12,4.79,8.35a17.37,17.37,0,0,1,2.27,9.56l0,.18a21.55,21.55,0,0,1-.58,3.28A20.78,20.78,0,0,1,328,257.9l-.06.15a17.46,17.46,0,0,1-6.75,7.16c-2.2,1.3-5.26,3.06-8.31,4.82s-6.07,3.5-8.26,4.79a2.68,2.68,0,0,0-1.56,2.87,51,51,0,0,0,1.73,8.75,50.13,50.13,0,0,0,2.88,8.44,2.67,2.67,0,0,0,2.78,1.72c2.54,0,6,0,9.53,0s7.07,0,9.63,0a17.35,17.35,0,0,1,9.41,2.81l.15.11A22.91,22.91,0,0,1,341.66,301.68Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M376,299.55a32.43,32.43,0,0,1-8.38-1.11,32,32,0,1,1,8.38,1.11ZM376,244a23.32,23.32,0,1,0,22.55,29.35h0A23.31,23.31,0,0,0,382,244.84,23.4,23.4,0,0,0,376,244Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilityManagement);
export default __webpack_public_path__ + "static/media/Facility Management.18e45e72c171d8ea34e59a8d8e4b5528.svg";
export { ForwardRef as ReactComponent };